import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An5(props) {
    const { nodes } = useGLTF('3ds/an/An5.gltf');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An5) {
                        global.gw.geometries.An5 = e.geometry;
                    }
                }}
                name="An5"
                geometry={nodes.An5.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An5.gltf')